import { useState, useEffect } from 'react'
import FilterList from './FilterList'
import {
  BTN_CLEAR_ALL,
  GENERAL_FILTER_TITLE,
} from '@components/utils/textVariables'
import { ACTION_TYPES } from '@components/utils/constants'
import { FiltersCloseIcon } from '@components/icons'

interface Props {
  products: any
  handleFilters: any
  routerFilters: any
  clearAll: any
  swrLoading: any
}

export default function CollectionFilters({
  products = { filters: [] },
  handleFilters,
  routerFilters,
  clearAll,
}: Props) {
  const [appliedFilters, setAppliedFilters] = useState<any[]>([])
  const [productFilters, setProductFilters] = useState<any[]>([])

  useEffect(() => {
    const currentFilters = products?.filters?.reduce(
      (acc: any, obj: any) => {
        acc.forEach((item: any) => {
          if (item.Key === obj.key) {
            item['name'] = obj.name
            return item
          }
          return acc
        })
        return acc
      },
      [...routerFilters]
    )
    setAppliedFilters(currentFilters)
    setProductFilters(products?.filters)
  }, [routerFilters.length, products?.filters, products?.pages])

  const removeAppliedFilter = (rm: any) =>
    handleFilters(rm, ACTION_TYPES.REMOVE_FILTERS)

  return (
    <div className="bg-transparent">
      {/* Mobile filter dialog */}
      <div className="relative flex flex-col w-full h-full max-w-xs py-4 pb-6 overflow-x-hidden overflow-y-auto bg-white">
        <div className="flex items-center justify-between px-0">
          <h4 className="text-lg font-medium text-gray-900">
            {GENERAL_FILTER_TITLE}
          </h4>
          {appliedFilters?.length > 0 && (
            <div>
              <button
                onClick={clearAll}
                type="button"
                className="text-xs font-semibold text-orange-500 underline uppercase"
              >
                {BTN_CLEAR_ALL}
              </button>
            </div>
          )}
        </div>

        <div className="flex flex-wrap gap-1 mt-2">
          {appliedFilters?.map((appliedFilter: any, idx: number) => {
            if (appliedFilter.Key === 'rating')
              return (
                <span
                  key={idx}
                  onClick={() => removeAppliedFilter(appliedFilter)}
                  className="flex justify-center items-center gap-x-2 relative rounded-lg inline-block px-5 text-sm font-normal text-black border bg-selected-facet cursor-pointer"
                >
                  <span>{parseFloat(appliedFilter.Value).toFixed(1)} ★ </span>
                  <button
                    type="button"
                    className="flex justify-center items-center"
                  >
                    <FiltersCloseIcon />
                  </button>
                </span>
              )
            return (
              <div
                key={`applied-filter-${idx}`}
                className="flex justify-center text-gray-600"
              >
                {appliedFilter.name ? (
                  <span
                    onClick={() => removeAppliedFilter(appliedFilter)}
                    className="flex justify-center items-center gap-x-2 relative rounded-lg inline-block px-5 text-sm font-normal text-black border bg-selected-facet cursor-pointer"
                  >
                    <span>{appliedFilter.Value}</span>
                    <button
                      type="button"
                      className="flex justify-center items-center"
                    >
                      <FiltersCloseIcon />
                    </button>
                  </span>
                ) : null}
              </div>
            )
          })}
        </div>
        {/* Filters */}
        <form className="mt-4">
          {productFilters?.map(
            (section: any) =>
              section.key != 'brandNoAnlz' &&
              section.name != 'Colour' &&
              section?.items?.length > 0 &&
              section.name != 'Price' && (
                <div
                  key={section.name}
                  className="px-0 py-6 border-t border-gray-200"
                >
                  <>
                    <h3 className="-mx-2 -my-3">
                      <div className="flex items-center justify-between w-full px-2 py-2 text-sm text-gray-400 bg-white">
                        <span className="font-semibold text-black capitalize">
                          {section.name == 'Filter Colour' ||
                          section.name == 'Filtercolour'
                            ? 'Colour'
                            : section.name}
                        </span>
                      </div>
                    </h3>
                    <div className="pt-3">
                      <div className="space-y-3">
                        <FilterList
                          handleFilters={handleFilters}
                          sectionKey={section.key}
                          items={section.items}
                          routerFilters={routerFilters}
                          sectionName={section.name}
                        />
                      </div>
                    </div>
                  </>
                </div>
              )
          )}
        </form>
      </div>
    </div>
  )
}
